import React, { FC } from 'react';

import { useSiteMetadata } from '@lucid/utils';
import { Helmet } from 'react-helmet';

import { PageMetatag } from '../../types/types';

export interface SEOProps {
  entityMetatags?: PageMetatag[] | null;
  shortLangPrefix?: string;
  pageType?: string;
  location: {
    pathname?: string | null;
  };
}

const SEO: FC<SEOProps> = ({
  entityMetatags = [],
  shortLangPrefix = 'en',
  pageType = 'defaultPageType',
  location
}) => {
  const { siteUrl, title, favicon } = useSiteMetadata();
  let shouldOverrideCanonical = false;
  const tagsWithName = ['description', 'keywords', 'robots'];
  return (
    <Helmet key={`${pageType}-seo-helmet`}>
      <title>{title}</title>
      {entityMetatags?.map(({ key, value }) => {
        let tag;
        if (key === 'title') {
          tag = <title key={key}>{value}</title>;
        } else if (key === 'canonical') {
          tag = <link key={key} href={value!} rel={key} />;
          shouldOverrideCanonical = true;
        } else if (tagsWithName.includes(key!)) {
          tag = <meta key={key!} content={value!} name={key!} />;
        } else {
          tag = <meta key={key!} content={value!} property={key!} />;
        }
        return tag;
      })}

      {!shouldOverrideCanonical && (
        <link key={`${siteUrl}${location.pathname}`} href={`${siteUrl}${location.pathname}`} rel="canonical" />
      )}
      <link key="shortcut-icon" href={favicon} rel="shortcut icon" type="image/png" />
      <html
        className={pageType ? `pageType__${pageType}` : ''}
        data-lang={shortLangPrefix}
        data-template={pageType ?? 'unknown'}
        lang={shortLangPrefix}
      />
    </Helmet>
  );
};

export default SEO;
